import type { Messages } from "./messages";
import { elideBeforeNumber } from "./elision";

type Vars = Record<string, string | number>;

// Fills one placeholder, letting the article before each occurrence agree with the number.
const fillPlaceholder = (text: string, placeholder: string, value: string, locale?: string) => {
  const pieces = text.split(placeholder);
  if (pieces.length === 1) return text;
  return pieces.reduce((result, piece, index) => {
    if (index === 0) return piece;
    return (elideBeforeNumber(locale, result, value) ?? result) + value + piece;
  }, "");
};

export const translate = (messages: Messages, key: string, vars?: Vars, locale?: string) => {
  const template = messages[key] ?? key;
  if (!vars) return template;

  return Object.keys(vars).reduce((acc, token) => {
    return fillPlaceholder(acc, `{{${token}}}`, String(vars[token]), locale);
  }, template);
};
